const gutter="24px";

export   {gutter};
export default gutter; 